import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

export const TopOfferInfoSkeleton = () => (
  <Box
    display="flex"
    flexDirection="column"
    width="100%"
    justifyContent="flex-end"
    paddingBottom="s200"
  >
    <SkeletonLoader width={90} />
    <SkeletonLoader width={139} />
  </Box>
)
